import { Navigate, useOutlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { AppBar } from "./Navbar/Navbar";

export const HomeLayout = () => {
  const { user } = useAuth();
  const outlet = useOutlet();

  if (user) {
    return <Navigate to="/reports/report" replace />;
  }

  return (
    <div>
      <AppBar />
      {outlet}
    </div>
  );
};
